/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferFormBidAttachmentViewModel
 */
export interface OfferFormBidAttachmentViewModel {
    /**
     * 
     * @type {number}
     * @memberof OfferFormBidAttachmentViewModel
     */
    attachmentId?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferFormBidAttachmentViewModel
     */
    fee?: number;
}

export function OfferFormBidAttachmentViewModelFromJSON(json: any): OfferFormBidAttachmentViewModel {
    return OfferFormBidAttachmentViewModelFromJSONTyped(json, false);
}

export function OfferFormBidAttachmentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferFormBidAttachmentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attachmentId': !exists(json, 'attachmentId') ? undefined : json['attachmentId'],
        'fee': !exists(json, 'fee') ? undefined : json['fee'],
    };
}

export function OfferFormBidAttachmentViewModelToJSON(value?: OfferFormBidAttachmentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attachmentId': value.attachmentId,
        'fee': value.fee,
    };
}

